<template>
  <v-form v-model="valid" ref="form">
    <v-container fluid class="px-6 mt-4">
      <v-row>
        <v-col cols="12" sm="6" md="4">
          <v-text-field label="Description on sales forms" v-model="product.sellingBondedDescription" :rules="[fieldRules.maxLength(100)]" :counter="100" outlined dense/>
        </v-col>
      </v-row>

      <v-row dense v-if="values && connectedToAccounting">
        <v-col  cols="12" sm="6" md="4">
          <account-picker v-model="product.bondedIncomeAccountRef" label="Income account"
                          :accounts="incomeAccounts" :addTypes="['Income']"
                          hint="The income account is used to track in-bond sales of this product."/>
        </v-col>
        <v-col  cols="12" sm="6" md="4">
          <account-picker v-model="product.bondedCogAccountRef" label="Cost of goods account"
                          :accounts="cogAccounts" :addTypes="['CostOfGoodsSold']"
                          hint="The cost of goods account is used to track in-bond sales of this product"/>
        </v-col>
      </v-row>

      <v-row >
        <v-col cols="6" sm="3" md="2">
          <decimal-number-input dense label="Default price" suffix="/case" v-model="product.defaultBondedPrice"/>
        </v-col>
        <v-col cols="6" sm="3" md="2">
          <v-autocomplete  outlined dense label="Default tax" v-model="product.defaultBondedTaxId" :items="taxes" item-value="id" item-text="name"/>
        </v-col>
        <v-col cols="12" sm="4" md="3">
          <v-checkbox dense label="Commission exempt" v-model="product.inBondCommissionExempt"/>
        </v-col>
      </v-row>

      <component v-if="product.alcoholType==='Spirit'" :is="province" :product="product" :taxes="taxes"/>

      <v-row>
        <v-col cols="12" lg="9">
          <customer-pricing :customers="product.bondedCustomers" :taxes="taxes"
                            :default-sku="product.sku" :defaultPrice="product.defaultBondedPrice" :defaultTaxId="product.defaultBondedTaxId" units="Case"/>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import CustomerPricing from '@/components/CustomerPricing'

export default {
  name: 'InventoryProductsEditBondedSelling',
  components: {CustomerPricing},
  props: {
    product: {type:Object, required:true},
    taxes: {type:Array, required:true},
    incomeAccounts: {type:Array, required:true},
    cogAccounts: {type:Array, required:true},
    values: {type:Boolean, required:true}
  },
  data() {
    return {
      valid: true,
      province: null
    }
  },
  computed: {
    connectedToAccounting() {
      return this.$store.getters.company.connectedToAccounting;
    }
  },
  watch: {
    item: {
      handler() {this.$emit('input', true);},
      immediate: true,
      deep: true
    }
  },
  async created() {
    this.province = () => ({component:import(`@/views/provinces/${this.$store.getters.company.province}/product/BondedSelling`)});
    setTimeout(() => {if (this.$refs.form) this.$refs.form.validate()},2000);
  }
}
</script>